import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-google-icon',
    templateUrl: './google-icon.component.html',
    styleUrls: ['./google-icon.component.scss'],
    standalone: false
})
export class GoogleIconComponent {
  @Input('classes')
  public classes = 'w-24px h-24px';
}
